import {GetterTree} from 'vuex'
import CacheItem from "../ts/CacheItemInterface";
import * as moment from "moment";

export const getters: GetterTree<any, any> = {

    /**
     * Get all active filters
     *
     * @param state
     * @param getters
     * @param rootState
     */
    activeFilters: (state, getters, rootState) => (filters: Array<any>) => {

        let activeFilters: any = {};

        filters.forEach((filter: any) => {
            if (filter.model && filter.menu) {
                const option = filter.menu.options.find((option: any) => option.model);
                activeFilters[filter.type] = option.value;
            } else if (filter.model && filter.type === 'queryFilter') {
                activeFilters[filter.type] = {
                    query: filter.custom.jsonQuery,
                    filter: filter.custom.jsonFilter
                }
            } else if (filter.model) {
                activeFilters[filter.type] = true;
            }
        });

        return activeFilters;
    },

    /**
     * Gets cache item based on the computer hash value
     *
     * @param state
     * @param getters
     */
    getCacheItem: (state, getters) => (cacheHash: string) => {

        const found = state.cache.find((cache: CacheItem) => cache.hash === cacheHash);

        if (found && moment().isBefore(found.expires)) {
            return found;
        }

        return false;
    }
};
